import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
    RadialLinearScale,
    ArcElement,
    BarElement,
} from 'chart.js';
import { Chart as RChart } from 'react-chartjs-2';
import { IChartLayout } from '../../types/layout/chart';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
    RadialLinearScale,
    ArcElement,
    BarElement,
);

function Chart({ chartType, data, style }: IChartLayout) {
    return (
        <RChart
            type={chartType}
            data={data}
            style={style}
        />
    );
}

export default Chart;
